/**
 * Helpers de formatage partagés (Batch #14.255 — consolidation des doublons fmtCAD / fmtMoney / money / dollars / today / r2 / addDays).
 */
export const fmtCAD = (n) => `${Number(n || 0).toLocaleString("fr-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} $`;
export const today = () => new Date().toISOString().slice(0, 10);
export const r2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
export const addDays = (iso, n) => { const d = new Date(iso + "T00:00:00"); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
